export default __webpack_public_path__ + "locales/tr/Translations.json?hash=d7a7be3a80e60e291df3c176600926bf";